export default __webpack_public_path__ + "static/media/fox_expired.3488683e.png";